export default class Files {
  constructor(data = {}) {
    this.user_id = data.user_id || null;
    this.name = data.name || null;
    this.file = data.file || null;
    this.size = data.size || null;
    this.id = data.id || null;
    this.folder_id = data.folder_id || null;
    this.folder_name = data.folder_name || null;
    this.updated_at = data.updated_at || null;
    this.created_at = data.created_at || null;
    this.signed_file = data.signed_file || null;
    this.visibility = data.visibility || null;
    this.recycle_bin = data.recycle_bin || false;
    this.folderName = data.folderName || data.folder_name || null;
  }
  empty() {
    this.user_id = null;
    this.name = null;
    this.file = null;
    this.size = null;
    this.id = null;
    this.folder_id = null;
    this.updated_at = null;
    this.created_at = null;
    this.signed_file = null;
    this.visibility = null;
    this.recycle_bin = false;
    this.folderName = null;
  }
  isEmpty() {
    return !this.id && !this.name;
  }
  isFilled() {
    return this.id && this.name;
  }
}
